// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3ueoY","header":"MessagesList_header__1zAPI","chat":"MessagesList_chat__1Tocv"};